import { ForwardRefExoticComponent, RefAttributes } from "react";
import { Brain, FileText, LucideProps, MessageCircle } from "lucide-react";

type Feature = {
	uuid: string;
	title: string;
	description: string;
	icon: ForwardRefExoticComponent<Omit<LucideProps, "ref"> & RefAttributes<SVGSVGElement>>;
};

export const academicFeatures: Feature[] = [
	{
		uuid: "a196a73f-a5f0-4fae-b915-c13f47c73bd0",
		title: "Hybrid Learning",
		description: "Seamlessly blend in-person and online education",
		icon: FileText,
	},
	{
		uuid: "a196a73f-a5f9-48a3-9aef-46e8905c347e",
		title: "Digital Assignments",
		description: "Create, distribute and grade assignments digitally",
		icon: Brain,
	},
	{
		uuid: "a196a73f-a5fc-470e-86f6-f66aafcddf24",
		title: "Seamless Communication",
		description: "Connect students, teachers and parents efficiently",
		icon: MessageCircle,
	},
];
